<script setup lang="ts">
import '@/assets/styles/career.css';
import {ref} from "vue";
import axios from 'axios';

const form = ref({
  name: "",
  forename: "",
  email: "",
  number: "",
  position: "kfz-mechatroniker",
  resume: null as File | null,
  cover: null as File | null,
  data: false
});

const showForm = ref(false);
const showToast = ref(false);
const toastMessage = ref("");
const submitted = ref(false);
const error = ref('');
const showConfirmToast = ref(false);

const handleFileUpload = (event: Event, type: "resume" | "cover") => {
  const target = event.target as HTMLInputElement;
  if (target.files && target.files[0]) {
    form.value[type] = target.files[0];
  }
};

const submitForm = async () => {
  showConfirmToast.value = true;
};

const confirmSubmission = async () => {
  showConfirmToast.value = false;
  error.value = '';

  try {
    const formData = new FormData();
    formData.append('name', form.value.name);
    formData.append('forename', form.value.forename);
    formData.append('email', form.value.email);
    formData.append('number', form.value.number);
    formData.append('position', form.value.position);

    if (form.value.resume) formData.append('resume', form.value.resume);
    if (form.value.cover) formData.append('cover', form.value.cover);

    await axios.post("/api/application", formData, {
      headers: {'Content-Type': 'multipart/form-data'}
    });

    submitted.value = true;
    toastMessage.value = "Ihre Bewerbung wurde uebermittelt.";
    showToast.value = true;

    setTimeout(() => showToast.value = false, 4000);
    resetForm();
    showForm.value = false;
  } catch (err) {
    error.value = 'Fehler beim Versenden';
    console.error(err);
  }
};

const cancelSubmission = () => {
  showConfirmToast.value = false;
};

const resetForm = () => {
  form.value = {
    name: "",
    forename: "",
    email: "",
    number: "",
    position: "kfz-mechatroniker",
    resume: null,
    cover: null,
    data: false
  };
};

const openForm = (position: string) => {
  form.value.position = position;
  showForm.value = true;
};

const closeForm = () => {
  showForm.value = false;
};
</script>

<template>
  <div class="career">
    <div v-if="showToast" class="toast">
      {{ toastMessage }}
    </div>

    <div v-if="showConfirmToast" class="confirm-toast-overlay">
      <div class="confirm-toast-box">
        <div class="confirm-icon">B</div>
        <p class="confirm-eyebrow">Bewerbung versenden</p>
        <h2>Bewerbung abschicken?</h2>
        <p class="confirm-copy">
          Wir übermitteln Ihre Bewerbung sicher an KFZ Musterwerkstatt. Bitte prüfen Sie vorher, ob Ihre Angaben und Anlagen vollständig sind.
        </p>
        <div class="confirm-toast-buttons">
          <button class="cancel-btn" type="button" @click="cancelSubmission">Abbrechen</button>
          <button class="confirm-btn" type="button" @click="confirmSubmission">Bewerbung absenden</button>
        </div>
      </div>
    </div>

    <section class="hero-career">
      <h1>Karriere bei KFZ Musterwerkstatt</h1>
      <p>Wir benoetigen Verstaerkung, treten Sie unserem Team bei.</p>
    </section>

    <section class="career-jobs">
      <h2>Offene Stellen</h2>
      <div class="job-card" @click="openForm('kfz-mechatroniker')">
        <h3>Kfz-Mechatroniker (m/w/d)</h3>
        <p>Wir suchen aktuell einen erfahrenen Kfz-Mechatroniker zur Verstaerkung unseres Teams.</p>
      </div>
    </section>

    <section class="career-form">
      <div class="popup-overlay" v-show="showForm" @click.self="closeForm">
        <div class="popup-box">
          <button class="close-btn" @click="closeForm">x</button>
          <h2>Jetzt bewerben</h2>
          <p class="form-intro">Senden Sie uns Ihre Kontaktdaten und Unterlagen. Wir prüfen Ihre Bewerbung persönlich und melden uns zeitnah zurück.</p>
          <form @submit.prevent="submitForm">
            <label>
              Name:
              <input type="text" v-model="form.name" required/>
            </label>

            <label>
              Vorname:
              <input type="text" v-model="form.forename" required/>
            </label>

            <label>
              E-Mail:
              <input type="email" v-model="form.email" required/>
            </label>

            <label>
              Telefonnummer:
              <input type="text" v-model="form.number" required/>
            </label>

            <label>
              Position:
              <select v-model="form.position" required>
                <option value="kfz-mechatroniker">Kfz-Mechatroniker</option>
              </select>
            </label>

            <label>
              Lebenslauf (PDF):
              <div class="file-upload-wrapper">
                <span class="upload-btn">
                  {{ form.resume ? form.resume.name : "PDF auswaehlen..." }}
                </span>
                <input type="file" @change="handleFileUpload($event, 'resume')" accept=".pdf"/>
              </div>
            </label>

            <label>
              Anschreiben (PDF):
              <div class="file-upload-wrapper">
                <span class="upload-btn">
                  {{ form.cover ? form.cover.name : "PDF auswaehlen..." }}
                </span>
                <input type="file" @change="handleFileUpload($event, 'cover')" accept=".pdf"/>
              </div>
            </label>

            <label class="checkbox-label">
              <span class="checkbox-text">
                Ich stimme der Verarbeitung meiner Daten gemaess
                <a href="/datenschutz" target="_blank">Datenschutzerklaerung</a>
                zu.
              </span>

              <input type="checkbox" v-model="form.data" required/>
              <span class="custom-checkbox"></span>
            </label>

            <p v-if="error">{{ error }}</p>

            <button type="submit">Bewerbung absenden</button>
          </form>
        </div>
      </div>
    </section>
  </div>
</template>

<style scoped>
</style>
